import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TooltipContent } from "@faire/retailer-visitor-shared/features/PointOfSale/components/PDPInventory/TooltipContent";
import { POSLogo } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { Tooltip } from "@faire/retailer-visitor-shared/features/PointOfSale/components/Tooltip";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useAssignSettingPDPInventory, useSettingPDPInventory } from "@faire/retailer-visitor-shared/settings/useSettingPDPInventory";
import { Row } from "@faire/web--source/slate/Layout";
import { TooltipTypography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerPosPdpInventoryCountView } from "@faire/web-api--source/events/retailerPos/view/pdpInventoryCount";
import { trackRetailerPosPdpInventoryTooltipView } from "@faire/web-api--source/events/retailerPos/view/pdpInventoryTooltip";
import { IGetProductOptionInventoryRequest } from "@faire/web-api--source/indigofair/retailers/pos/IGetProductOptionInventoryRequest";
import { useQuery_escape_hatch as useInventoryQuery } from "@faire/web-api--source/retailers-pos-api/product-option-inventory/post-hooks";
import React, { useEffect, useMemo } from "react";
export var ProductOptionPOSInventory = function(param) {
    var optionToken = param.optionToken;
    var showInventory = useSettingPDPInventory();
    var assignPDPInventory = useAssignSettingPDPInventory();
    var _usePOSSummary = usePOSSummary(), type = _usePOSSummary.type, posCompanyName = _usePOSSummary.name, hasLinkedPOS = _usePOSSummary.hasLinkedPOS;
    // TODO(Fabio): remove these events and forwarded refs when removing PDP_INVENTORY_COUNTS_RELAUNCH_3_250107
    var inventoryViewRef = useDoActionWhenVisible(function() {
        return trackRetailerPosPdpInventoryCountView(optionToken);
    });
    var tooltipViewRef = useDoActionWhenVisible(function() {
        return trackRetailerPosPdpInventoryTooltipView(optionToken);
    });
    var data = useInventoryQuery(IGetProductOptionInventoryRequest.build({
        product_option_tokens: [
            optionToken
        ]
    }), {
        enabled: hasLinkedPOS
    }).data;
    var inventoryCountNumber = useMemo(function() {
        var _data_inventory_data_by_product_option_optionToken;
        return data === null || data === void 0 ? void 0 : (_data_inventory_data_by_product_option_optionToken = data.inventory_data_by_product_option[optionToken]) === null || _data_inventory_data_by_product_option_optionToken === void 0 ? void 0 : _data_inventory_data_by_product_option_optionToken.total_inventory;
    }, [
        data,
        optionToken
    ]);
    useEffect(function() {
        if (inventoryCountNumber !== undefined) {
            assignPDPInventory();
        }
    }, [
        inventoryCountNumber,
        assignPDPInventory
    ]);
    if (!showInventory || !hasLinkedPOS || inventoryCountNumber === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        target: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            gap: 4,
            ref: inventoryViewRef,
            children: [
                /*#__PURE__*/ _jsx(POSLogo, {
                    type: type
                }),
                /*#__PURE__*/ _jsx(TooltipTypography, {
                    style: {
                        cursor: "default"
                    },
                    children: inventoryCountNumber > 99 ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "xXpyaW",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "99+ in "
                            },
                            {
                                type: 1,
                                value: "posCompanyName"
                            }
                        ],
                        values: {
                            posCompanyName: posCompanyName
                        }
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "AAVLrR",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "inventoryCountNumber",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " in "
                                            },
                                            {
                                                type: 1,
                                                value: "posCompanyName"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " in "
                                            },
                                            {
                                                type: 1,
                                                value: "posCompanyName"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: {
                            inventoryCountNumber: inventoryCountNumber,
                            posCompanyName: posCompanyName
                        }
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(TooltipContent, {
            ref: tooltipViewRef
        })
    });
};
